import React, { Fragment } from 'react';
import { TextField } from '@gerdau/hefesto';
import moment, { isMoment } from 'moment';
import { ISelectedTableOrders, UpdateErrorMsgMap, UpdateErrorType } from '..';
import { BoldText, WarningText } from '../styles';
import { DateContainer } from './styles';
import DateInput from '../../../../../../../../components/Purchase/DateInput';
import { addBusinessDays } from '../utils';

interface IDateUpdate {
  selectedItens: ISelectedTableOrders[];
  onChangeDate: (
    date: string,
    orderId: string,
    materialId: string,
    key: 'newDate'
  ) => void;
  warningComponents: JSX.Element[] | null;
  hasUpdateError: boolean;
}

const DateUpdate: React.FC<IDateUpdate> = ({
  selectedItens,
  onChangeDate,
  warningComponents,
  hasUpdateError
}) => {
  return (
    <>
      <p>
        <BoldText>Ajuste na entrega</BoldText>
      </p>
      <p>
        Defina uma nova data para seu pedido. As novas datas disponíveis começam
        a contar a partir de 3 dias úteis, pois esse é o prazo mínimo para
        preparar o seu pedido.
      </p>
      {!hasUpdateError && warningComponents?.length
        ? warningComponents.map((component, index) => (
            <Fragment key={index}>{component}</Fragment>
          ))
        : null}
      {hasUpdateError && (
        <>
          {selectedItens.map((item) => {
            if (
              item.materials.some(
                (m) => m.errorType && m.errorType !== UpdateErrorType.QUANTITY
              )
            ) {
              return (
                <Fragment key={item.orderNumber}>
                  <WarningText>
                    Para o pedido <strong>{item.orderNumber}</strong> {': '}
                    {item.materials.map((material) => {
                      if (material.errorType) {
                        return (
                          <div
                            key={material.id}
                            style={{ marginBottom: '1rem' }}
                          >
                            <span>
                              O item <strong>{material.description}</strong> não
                              pôde ser alterado porque{' '}
                              <strong>
                                {material.errorType === UpdateErrorType.ITEM &&
                                material.updateErrorMessage
                                  ? material.updateErrorMessage
                                  : UpdateErrorMsgMap.get(material.errorType)}
                              </strong>
                            </span>
                            <br />
                          </div>
                        );
                      }
                    })}
                  </WarningText>
                </Fragment>
              );
            }
          })}
          {selectedItens
            .flatMap((items) => items.materials)
            .some(
              (m) => m.errorType && m.errorType !== UpdateErrorType.QUANTITY
            ) && (
            <WarningText>
              <strong>
                Selecione na tabela apenas o item que pode ser alterado.
              </strong>
            </WarningText>
          )}
        </>
      )}
      {selectedItens.map((order) => {
        return (
          <Fragment key={order.orderNumber}>
            <p>
              <BoldText>Pedido nᵒ {order.orderNumber}</BoldText>
            </p>
            {order.materials.map((material) => {
              return (
                <Fragment key={material.id}>
                  <span>{material.description}</span>
                  <DateContainer>
                    <TextField
                      label="De"
                      name="Requested material date"
                      value={
                        isMoment(material.requestedDate)
                          ? material.requestedDate.format('DD/MM/YYYY')
                          : moment(material.requestedDate).format('DD/MM/YYYY')
                      }
                      readOnly
                    />
                    <DateInput
                      label="Para"
                      minimumDate={addBusinessDays(3)}
                      onSelectDate={(date) =>
                        onChangeDate(
                          date,
                          material.id.toString(),
                          order.orderNumber,
                          'newDate'
                        )
                      }
                      width="24"
                      value={material.newDate}
                      disabled={
                        !material.changeAllowed ||
                        material.errorType === UpdateErrorType.DATE ||
                        material.errorType === UpdateErrorType.STATUS ||
                        material.errorType === UpdateErrorType.ORDER_TYPE
                      }
                    />
                  </DateContainer>
                </Fragment>
              );
            })}
          </Fragment>
        );
      })}
    </>
  );
};

export default DateUpdate;
